import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLazyQuery } from '@apollo/react-hooks';
import { Modal } from 'semantic-ui-react';
import DEFAULT_IMAGE from '../assets/default_Images/default_Image.jpg';
import { BiMessageSquareError } from 'react-icons/bi';
import { motion } from 'framer-motion';
import { AiOutlineDollarCircle } from 'react-icons/ai';
import { MdMoneyOff } from 'react-icons/md';
import capitalize from 'lodash/capitalize';
import { VscCloseAll, VscTag } from 'react-icons/vsc';
import lang from '../utils/translations';
import Spinner from '../common/Spinner';
import { SEARCH_BOOK } from '../graphql/query';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function SearchModal({ open, close, text }) {
  const history = useHistory();
  const [search, SetSearch] = useState({
    keyword: text,
  });

  const [fetchSeachedBooks, { loading, error, data }] = useLazyQuery(SEARCH_BOOK);
  useEffect(() => {
    if (Boolean(text.length)) {
      fetchSeachedBooks({ variables: { keyword: text } });
      SetSearch(() => ({ keyword: '' }));
    }
    //eslint-disable-next-line
  }, []);
  const onSubmit = e => {
    e.preventDefault();
    if (e.keyCode === 13) {
      fetchSeachedBooks({ variables: { keyword: search.keyword || text } });
    }
  };
  const onChange = e => SetSearch({ keyword: e.target.value });
  const GoToContent = slug => {
    close();
    history.push(`/contents/${slug}`);
  };

  return (
    <div>
      {open && (
        <Modal centered={false} size="small" open={open} onClose={close}>
          <div className="d-flex flex-nowrap align-items-center justify-content-start shadow p-2">
            <input
              onKeyUp={onSubmit}
              value={search.keyword}
              onChange={onChange}
              name="keyword"
              className="border-0 w-100 p-3"
              type="text"
              placeholder="Search book or author and then Press Enter..."
            />
            <div data-toggle="tooltip" title="Close search">
              <VscCloseAll className="text-blue-darken cursor-pointer" size={30} onClick={close} />
            </div>
          </div>
          {loading ? (
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
              <Spinner />
            </div>
          ) : error ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
              <div className="d-flex align-items-center justify-content-center gap-2">
                <BiMessageSquareError size={60} className="text-grey" />
                <span className="fw-bold h4 text-grey">{error.graphQLErrors[0] ? error.graphQLErrors[0].message : 'Search Again'}</span>
              </div>
            </div>
          ) : !Boolean(data?.search.length) ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
              <div className="d-flex align-items-center justify-content-center gap-2">
                <BiMessageSquareError size={60} className="text-grey" />
                <span className="fw-bold h4 text-grey">No data found!</span>
              </div>
            </div>
          ) : (
            <div className="col-lg-12 p-3 gap-3 d-flex flex-wrap justify-content-start align-items-start">
              {React.Children.toArray(
                data.search.map((book, index) => {
                  const allTags = book.tags.filter(({ tagName }, i) => tagName.length >= 3) || [];
                  return (
                    <motion.div
                      whileHover={{ scale: 1.15 }}
                      className="d-flex justify-content-start flex-nowrap gap-2 shadow cursor-pointer user-select-none"
                      style={{ borderTopLeftRadius: 40, borderBottomRightRadius: 40 }}
                      onClick={() => GoToContent(book?.slug)}
                    >
                      <img
                        src={book?.coverUrl ? book?.coverUrl : DEFAULT_IMAGE}
                        alt={`Book Cover ${book.name}`}
                        style={{ width: 150, height: 170, objectFit: 'fill', borderTopLeftRadius: 40, borderBottomRightRadius: 40 }}
                      />
                      <div className="p-2" style={{ overflow: 'hidden', width: 175 }}>
                        <p className="fw-bold fs-5 text-blue-darken text-truncate m-0 pb-2" data-toggle="tooltip" title={book?.name}>
                          {capitalize(book?.name)}
                        </p>
                        <p className="d-flex align-items-center justify-content-start flex-nowrap m-0 pb-2">
                          {book?.price !== 0 ? <AiOutlineDollarCircle className="me-1 text-blue-darken" size={35} /> : <MdMoneyOff size={35} className="me-1 text-blue-darken" />}
                          <span className="fw-bold fs-5 text-blue-darken">{book?.price !== 0 ? book?.price : 'Free'}</span>
                        </p>
                        <p className="fw-light text-secondary text-truncate fs-6 m-0 pb-2" data-toggle="tooltip" title={book?.author}>
                          Authored {lang.t('By')} {capitalize(book?.author)}
                        </p>
                        <p className="fw-light text-secondary text-truncate fs-6 m-0 pb-2" data-toggle="tooltip" title={book?.publishedCompany}>
                          {lang.t('Published')} {lang.t('By')} {capitalize(book?.publishedCompany)}
                        </p>

                        <div className="d-flex justify-content-start flex-nowrap gap-5 py-2 pe-2" style={{ borderTop: '5px solid #ccc' }}>
                          {React.Children.toArray(
                            Boolean(allTags.length) &&
                              allTags?.slice(0, 1).map(
                                ({ tagName }) =>
                                  tagName.length >= 3 && (
                                    <div className="d-flex gap-2 align-items-center flex-nowrap text-center py-2 px-3 bg-chocolate text-white fw-light fs-6">
                                      <VscTag className="text-white" size={15} />
                                      {tagName}
                                    </div>
                                  ),
                              ),
                          )}
                        </div>
                      </div>
                    </motion.div>
                  );
                }),
              )}
            </div>
          )}
        </Modal>
      )}
    </div>
  );
}
